import { Component, OnInit } from '@angular/core';
import { BlacklistTableDataSource } from './blacklist-table.data';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import {
  AddNumbersToBlacklistAction,
  ExpandMsisdnAction,
  RemoveNumbersToBlacklistAction
} from '../blacklist/blacklist.actions';
import { Blacklist } from '../blacklist/blacklist';
import { DateRange } from '../../shared/date-range-picker/date-range';
import { MatCheckboxChange } from '@angular/material/checkbox/typings/checkbox';

@Component({
  selector: 'cc-blacklist-table',
  templateUrl: './blacklist-table.component.html',
  styleUrls: ['./blacklist-table.component.scss']
})
export class BlacklistTableComponent implements OnInit {
  public displayedColumns = ['open-action', 'number', 'user', 'date', 'status', 'select'];
  public searchForm: FormGroup;
  public showDateRangePicker: boolean;

  constructor(public dataSource: BlacklistTableDataSource, private store: Store<IState>, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.createSearchForm();
  }

  createSearchForm() {
    this.searchForm = this.fb.group({
      msisdnLike: null
    });
  }

  onChanged(event, element) {
    this.store.dispatch(
      new ExpandMsisdnAction({
        element,
        expanded: !element.expanded
      })
    );
  }

  addToBlacklist() {
    this.store.dispatch(
      new AddNumbersToBlacklistAction(this.dataSource.selection.selected.map((el: Blacklist) => el.msisdn))
    );
  }

  removeToBlacklist() {
    this.store.dispatch(
      new RemoveNumbersToBlacklistAction(this.dataSource.selection.selected.map((el: Blacklist) => el.msisdn))
    );
  }

  filterByDate(event: MatCheckboxChange) {
    this.showDateRangePicker = event.checked;
    if (!this.showDateRangePicker) {
      this.dataSource.search(<DateRange>{
        dateFrom: null,
        dateTo: null
      });
    }
  }
}
